module.exports = __webpack_public_path__ + "img/small-14.8d907579.jpg";